import React from "react";
import Withdrawal from "./walletComponents/withdraw";
import Deposit from "./walletComponents/deposit";
// import ModalRedirector from "@/ModalRedirector";
// import { json } from "stream/consumers";
import { GetMethods, SetMethodsActive } from "$Deposits/store/actions/DepositAction";
import { connect } from "react-redux";
import { WalletProviderMapping } from "$DATA/gameUtils";
import { gameActions } from "$STORE/gameSlice";
import { getPagePiwikData } from "$ACTIONS/piwikData";
import { openCentralPaymentModal } from "$STORE/actions/CentralPaymentActions";
import { checkUserSelfExclusion } from "$ACTIONS/selfExclusionHelper";

const DEPOSIT = "deposit";
const WITHDRAW = "withdraw";
class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            depositDownOpen: false, // 充值下拉是否展开
            withdrawDownOpen: false, // 提款下拉是否展开
            withdrawMethodsList: [], //提款方式
            currentWithdrawKey: "", //当前的充值方式类型
            needDeposit: false,
        };
        this.changeTab = this.changeTab.bind(this); // 切换Tab选项卡
        this.toggleDepositList = this.toggleDepositList.bind(this); // 切换充值列表显示状态
        this.toggleWithdrawList = this.toggleWithdrawList.bind(this); // 切换提款列表显示状态
        this.setCurrentWithdrawMethod =
            this.setCurrentWithdrawMethod.bind(this); // 设置当前提现方式
        this.depositListWrapRef = React.createRef(); // 充值列表外层DOM
        this.depositListRef = React.createRef(); // 充值列表DOM
        this.withdrawListWrapRef = React.createRef(); // 提现列表外层DOM
        this.withdrawListRef = React.createRef(); // 提现列表DOM
        this.currentModalMap = { ...this.props.dialogTabKey }; // 当前Modal需要传递的属性对象
    }
    componentDidMount() {
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl("bank_center", "Bank Center");
        this.checkBalance();
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.dialogTabKey.type !== prevProps.dialogTabKey.type) {
            this.currentModalMap = { ...this.props.dialogTabKey };
            if (this.props.dialogTabKey.type === DEPOSIT) {
                this.toggleDepositList(this.props.dialogTabKey.type);
            } else if (this.props.dialogTabKey.type === WITHDRAW) {
                this.toggleWithdrawList(this.props.dialogTabKey.type);
            }
        }
        //提款方式有資料後，展開提款列表
        if (
            Array.isArray(this.state.withdrawMethodsList) &&
            this.state.withdrawMethodsList.length !==
                prevState.withdrawMethodsList.length &&
            this.props.dialogTabKey.type === WITHDRAW
        ) {
            if (this.state.withdrawMethodsList.length > 0) {
                this.toggleWithdrawList(true);
            }
        }
        //存款方式有資料後，展開存款列表
        if (
            prevProps.Methods !== this.props.Methods &&
            this.props.Methods &&
            this.props.Methods.paymentMethods &&
            Array.isArray(this.props.Methods.paymentMethods) &&
            this.props.Methods.paymentMethods.length &&
            this.props.dialogTabKey.type === DEPOSIT
        ) {
            this.toggleDepositList(true);
        }
        //刷新餘額，檢查是否顯示餘額不足 note
        if (prevProps.balanceInfo !== this.props.balanceInfo) {
            this.checkBalance();
        }
    }
    componentWillUnmount() {
        this.props.setOpenGameData(null);
        const pageData = getPagePiwikData();
        if (pageData) {
            global.Pushgtagpiwikurl &&
                global.Pushgtagpiwikurl(pageData.url, pageData.title);
        }
    }
    /**
     * @description: 在遊戲頁面開啟錢包，检查余额是否充足，进行相关执行
     * @return {*}
     */
    checkBalance = () => {
        const { balanceInfo, isGamePage, openGameData } = this.props;
        if (!isGamePage || !balanceInfo || !balanceInfo.balances || balanceInfo.balances.length === 0) {
            this.setState({ needDeposit: false });
            return;
        }

        const { balances } = balanceInfo;
        if (WalletProviderMapping && openGameData) {
            const walletGroupCode = this.getWalletGroupCode(openGameData);
            const hasLowBalance = balances.some(
                (balanceItem) =>
                    balanceItem.walletProductGroupCode === walletGroupCode &&
                    balanceItem.balance < 50
            );

            this.setState({ needDeposit: hasLowBalance });
        } else {
            this.setState({ needDeposit: false });
        }
    }

    getWalletGroupCode = (openGameData) => {
        return Object.entries(WalletProviderMapping)?.find(
            ([groupCode, providers]) =>
                providers.some(
                    (provider) =>
                        provider.provider === openGameData.provider &&
                        provider.gameType === openGameData.productCode
                )
        )?.[0];
    }

    setCurrentWithdrawMethod(key, type) {
        this.setState({ currentWithdrawKey: key });
    }

    toggleDepositList(status) {
        this.withdrawListWrapRef.current.style.height = 0;
        this.setState({ withdrawDownOpen: false });
        if (status === DEPOSIT && this.props.dialogTabKey.type !== DEPOSIT) {
            this.currentModalMap.type = DEPOSIT;
            this.props.setModalTabKey(this.currentModalMap);
        }
        const currentWrapRef = this.depositListWrapRef.current;
        const currWrapHeight = currentWrapRef.clientHeight;
        const currHeight = this.depositListRef.current.clientHeight;
        switch (status) {
            case true:
                this.setState({ depositDownOpen: true });
                currentWrapRef.style.height = currHeight + "px";
                break;
            case false:
                this.setState({ depositDownOpen: false });
                currentWrapRef.style.height = 0;
                break;
            default:
                this.setState({ depositDownOpen: !currWrapHeight });
                currentWrapRef.style.height = currWrapHeight
                    ? 0
                    : currHeight + "px";
                break;
        }

        status === DEPOSIT &&
            Pushgtagdata(
                "BankCenter",
                "Switch to Deposit",
                "BankCenter_C_Deposit"
            );
    }

    toggleWithdrawList(status) {
        this.depositListWrapRef.current.style.height = 0;
        this.setState({ depositDownOpen: false });
        if (status === WITHDRAW && this.props.dialogTabKey.type !== WITHDRAW) {
            this.currentModalMap.type = WITHDRAW;
            this.props.setModalTabKey(this.currentModalMap);
        }
        const currentWrapRef = this.withdrawListWrapRef.current;
        const currWrapHeight = currentWrapRef.clientHeight;
        const currHeight = this.withdrawListRef.current.clientHeight;
        switch (status) {
            case true:
                this.setState({ withdrawDownOpen: true });
                currentWrapRef.style.height = currHeight + "px";
                break;
            case false:
                this.setState({ withdrawDownOpen: false });
                currentWrapRef.style.height = 0;
                break;
            default:
                this.setState({ withdrawDownOpen: !currWrapHeight });
                currentWrapRef.style.height = currWrapHeight
                    ? 0
                    : currHeight + "px";
                break;
        }

        status === WITHDRAW &&
            Pushgtagdata(
                "BankCenter",
                "Switch to Withdrawal",
                "BankCenter_C_Withdrawal"
            );
    }

    async changeTab(tabName) {
        // 自我限制檢查
        if (tabName === DEPOSIT) {
            const hasSelfExclusion = await checkUserSelfExclusion((status) => {
                this.props.setLoading(status);
            }, "deposit");
            if (hasSelfExclusion) return;
        }

        this.currentModalMap.type = tabName;
        this.props.setModalTabKey(this.currentModalMap);
    }
    render() {
        let contentComponent;
        switch (this.props.dialogTabKey.type) {
            case DEPOSIT:
                contentComponent = (
                    <Deposit
                        onCancel={this.props.onCancel}
                        setLoading={(v, str) => {
                            this.props.setLoading(v, str);
                        }}
                        goUserCenter={this.props.goUserCenter}
                        isGamePage={this.props.isGamePage}
                    />
                );
                break;
            case "withdraw":
                contentComponent = (
                    <Withdrawal
                        setPayMethods={(list) => {
                            this.setState({ withdrawMethodsList: list });
                        }}
                        setCurrKey={(v) => {
                            this.setCurrentWithdrawMethod(v);
                        }}
                        currentWithdrawKey={this.state.currentWithdrawKey}
                        setLoading={(v, str) => {
                            this.props.setLoading(v, str);
                        }}
                        onCancel={this.props.onCancel}
                        goUserCenter={this.props.goUserCenter}
                    />
                );
                break;
            default:
                contentComponent = null;
                break;
        }
        return (
            <React.Fragment>
                <div className="wallet-wrap">
                    <div className="wallet-nav-wrap">
                        <div
                            className={`wallet-nav-item border-clear ${
                                this.state.depositDownOpen ? " open" : " close"
                            }`}
                            onClick={() => this.changeTab(DEPOSIT)}
                        >
                            ฝากเงิน
                            {/* 存款 */}
                            <img
                                className="anticon"
                                src="/th/img/wallet/icon-arrow-up.svg"
                            />
                        </div>
                        <div
                            className="deposit-list-wrap"
                            ref={this.depositListWrapRef}
                        >
                            <div
                                className="deposit-list"
                                ref={this.depositListRef}
                            >
                                {this.props.Methods?.paymentMethods?.map(
                                    (val, idx) => {
                                        return (
                                            <div
                                                key={val.code + idx}
                                                className={`${
                                                    val.isNew ? " isNew" : ""
                                                } deposit-item${
                                                    val.isFast ? " isFast" : ""
                                                }${
                                                    this.props.MethodsActive
                                                        .code === val.code
                                                        ? " active"
                                                        : ""
                                                }`}
                                                onClick={() => {
                                                    if (val.code === 'CTC' && this.props.useCentralPayment) {
                                                        this.props.openCentralPayment('deposit', 'CTC');
                                                    } else {
                                                        this.props.SetMethodsActive(val);
                                                    }
                                                }}
                                            >
                                                <i
                                                    className={`deposit-sprite ${val.code}`}
                                                />
                                                <span>{val.name}</span>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                        <div
                            className={`wallet-nav-item border-clear ${
                                this.state.withdrawDownOpen ? " open" : " close"
                            }`}
                            onClick={() => {
                                if (this.props.useCentralPayment) {
                                    this.props.openCentralPayment('withdrawal');
                                } else {
                                    this.changeTab(WITHDRAW)
                                }
                            }}
                        >
                            ถอนเงิน
                            {/* 提款 */}
                            <img
                                className="anticon"
                                src="/th/img/wallet/icon-arrow-up.svg"
                            />
                        </div>
                        <div
                            className="deposit-list-wrap"
                            ref={this.withdrawListWrapRef}
                        >
                            <div
                                className="deposit-list"
                                ref={this.withdrawListRef}
                            >
                                {this.state.withdrawMethodsList.map(
                                    (val, idx) => {
                                        return (
                                            <div
                                                key={val.code + idx}
                                                className={`deposit-item${
                                                    val.code === "CCW"
                                                        ? " new"
                                                        : ""
                                                }${
                                                    val.isFast ? " isFast" : ""
                                                }${
                                                    this.state
                                                        .currentWithdrawKey ===
                                                    val.code
                                                        ? " active"
                                                        : ""
                                                }`}
                                                onClick={() => {
                                                    this.setCurrentWithdrawMethod(
                                                        val.code
                                                    );
                                                    Pushgtagdata(
                                                        `Withdrawal`,
                                                        `Switch to ${val.code}`,
                                                        `Withdrawal_C_${val.code}`
                                                    );
                                                }}
                                            >
                                                <i
                                                    className={`deposit-sprite ${val.code}`}
                                                />
                                                <span>{val.name}</span>
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="wallet-content-wrap">
                        {this.props.isGamePage &&
                            this.props.dialogTabKey.type !== "withdraw" && (
                                <>
                                    {this.state.needDeposit && (
                                        <p
                                            className="yellowNote"
                                            dataCN="餘額不足，請存款"
                                        >
                                            ยอดเงินคงเหลือไม่เพียงพอ
                                            กรุณาทำการฝากเงิน
                                        </p>
                                    )}
                                </>
                            )}
                        {contentComponent}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => ({
    Methods: state.Methods,
    MethodsActive: state.MethodsActive,
    MethodsDetails: state.MethodsDetails,
    openGameData: state.game.openGameData,
    balanceInfo: state.balance.balanceInfo,
    useCentralPayment: state?.centralPaymentReducer?.useCentralPayment,
});
const mapDispatchToProps = {
    GetMethods: () => GetMethods(),
    SetMethodsActive: (data) => SetMethodsActive(data),
    setOpenGameData: (data) => gameActions.setOpenGameData(data),
    openCentralPayment: (type, method) => openCentralPaymentModal(type, method)
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
